import { render, staticRenderFns } from "./OnlineGiving.vue?vue&type=template&id=3aa86c88&"
import script from "./OnlineGiving.vue?vue&type=script&lang=js&"
export * from "./OnlineGiving.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports